import { ApiService } from "./ApiService"

export class PasswordService {

    static uri = '/password';

    static update({ data }) {
        return ApiService.post(`${this.uri}/update`, data,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }
}